module.exports = __webpack_public_path__ + "prod/1.42.2/img/icon-phone.c122f1e2.svg";